import React from 'react'
import {Route, Redirect} from "react-router-dom";
import {connect} from "react-redux";

const AuthRoute= ({component: Component, authenticated, ...rest}) => (
    <Route 
    {...rest}
    render={(props)=>authenticated === true ? <Component {...props} /> : <Redirect to="/transporter" />
    }
    />

)
const mapStateToProps = (state)=>({
    authenticated: state.user.authenticated
})

export default connect(mapStateToProps)(AuthRoute);